<template>
    <div>
        <vs-table class="dashboard3_freeze_row row2" :data="results" slot="no-body" :hoverFlat="true" stripe>
            <vs-tr>
                <vs-th>ID</vs-th>
                <vs-th style="min-width: 120px;">Organisation</vs-th>
                <vs-th style="min-width: 120px;">Issue Type</vs-th>
                <vs-th style="min-width: 120px;">Issue Date</vs-th>
                <vs-th style="min-width: 120px;">Date Created</vs-th>
                <vs-th style="min-width: 150px;">Approval Status</vs-th>
                <vs-th style="min-width: 150px;">Resolution Status</vs-th>
                <vs-th style="min-width: 150px;">Assigned Reviewers</vs-th>
                <vs-th style="min-width: 120px; text-align: center" class="col-cen">Action</vs-th>
            </vs-tr>
            <template>
                <template v-for="(item, index) in results">
                    <vs-tr :key="index">
                        <vs-td>
                            {{ item.data.id }}
                        </vs-td>
                        <vs-td>
                            {{ item.organisation.name }}
                        </vs-td>
                        <vs-td>
                            <FormatText :text="item.issue_type" format="select" :kwargs="issue_type_options" />
                        </vs-td>
                        <vs-td>
                            <FormatText :text="item.data[get_date_key(item.issue_type)]" format="date" />
                        </vs-td>
                        <vs-td>
                            <FormatText :text="item.created_on" format="datetime" />
                        </vs-td>
                        <vs-td>
                            <div v-if="item.status == 'p'" class="text-warning">
                                Pending
                            </div>
                            <div v-else-if="item.status == 'r'" class="text-danger">
                                Rejected
                            </div>
                            <div v-else-if="item.status == 'a'" class="text-success">
                                Approved
                            </div>
                        </vs-td>
                        <vs-td>
                            <div v-if="item.resolution_status == null" class="text-warning">
                                Not Started
                            </div>
                            <div v-else-if="item.resolution_status == 'p'" class="text-warning">
                                Pending
                            </div>
                            <div v-else-if="item.resolution_status == 'r'" class="text-danger">
                                Rejected
                            </div>
                            <div v-else-if="item.resolution_status == 'a'" class="text-success">
                                Approved
                            </div>
                        </vs-td>
                        <vs-td>
                            {{ item.assigned_reviewers.map(v => `${v.first_name} ${v.last_name}`).join(', ') }}
                        </vs-td>
                        <vs-td class="text-center">
                            <a :href="`/issues/${item.issue_type}?search=${item.id}&autoload_organisation=${item.organisation.id}`" target="_blank" class="view-btn">
                              View
                            </a>
                        </vs-td>
                    </vs-tr>
                </template>
            </template>
        </vs-table>
        <div class="flex-center mt-3">
            <vs-button type="filled" color="primary" class="mr-base" @click="$emit('prev_data', module_type, prev_link)" :disabled="!prev_link">Prev</vs-button>
            <vs-button type="filled" color="primary" @click="$emit('next_data', module_type, next_link)" :disabled="!next_link">Next</vs-button>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        results: {
            type: Array,
            required: true
        },
        module_type: {
            type: String,
            required: true,
        },
        next_link: {
            type: String || null,
            required: false,
            default: null
        },
        prev_link: {
            type: String || null,
            required: false,
            default: null
        },
    },
    data() {
        return {
            issue_type_options: [
                {value: 'routine_maintenance', label: 'Routine Maintenance'},
                {value: 'electrical_maintenance', label: 'Electrical Maintenance'},
                {value: 'major_maintenance', label: 'Major Maintenance'},
                {value: 'highway', label: 'Corrective Maintenance'},
                {value: 'enroachment_row', label: 'Enroachment Row'},
                {value: 'road_user_accident', label: 'Road User Accident'},
                {value: 'occupational', label: 'Occupational'},
                {value: 'hazard', label: 'Hazard'},
                {value: 'dead_animal_debris_removal', label: 'Dead Animal Debris Removal'},
                {value: 'vehicle_breakdown', label: 'Vehicle Breakdown'},
                {value: 'traffic_violation', label: 'Traffic Violation'},
                {value: 'unauthorised_parking', label: 'Unauthorised Parking'},
                {value: 'unauthorised_access', label: 'Unauthorised Access'},
                {value: 'unauthorised_media_cut', label: 'Unauthorised Median Cut'},
                {value: 'material_damage', label: 'Material Damage'},
                {value: 'other', label: 'Other'},
            ],

            issue_date: [
                'routine_maintenance', 
                'electrical_maintenance', 
                'major_maintenance', 
                'highway', 
                'occupational', 
                'hazard', 
                'dead_animal_debris_removal', 
                'vehicle_breakdown', 
                'unauthorised_access', 
                'unauthorised_media_cut', 
                'material_damage',  
                'enroachment_row'
            ],

            issue_date_of_accident: [
                'road_user_accident',
                'other',
                'traffic_violation'
            ]
        }
    },
    methods: {
        get_date_key(issue_type) {
            if (this.issue_date.includes(issue_type)) {
                return 'date'
            } else if (this.issue_date_of_accident.includes(issue_type)) {
                return 'date_of_accident'
            } else {
                return 'created_on'
            }
        }
    }
}
</script>

<style lang="scss">
.dashboard3_freeze_row {
  .vs-table--tbody {
    overflow-y: scroll;
    max-height: 350px;
  }
}

.dashboard3_freeze_row.row2 tr:nth-child(2) {
  position: sticky;
  opacity: 1 !important;
  z-index: 1000;
  top: 0;
}

</style>
